import { render, staticRenderFns } from "./consentForm.vue?vue&type=template&id=49a6d241&scoped=true"
import script from "./consentForm.vue?vue&type=script&lang=js"
export * from "./consentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6d241",
  null
  
)

export default component.exports